export interface IContentSizeItem {
    w: number;
    h: number;
}

export type IContentSizeMap = {
    [key in contentSize]: IContentSizeItem;
};

export const DEFAULT_GRID_BREAKPOINTS = Object.freeze({
    numColumnsMobile: 1,
    numColumnsDesktop: 4,
    numColumnsLargeScreen: 4,
    numColumnsExtraLargeScreen: 4
});

export const DEFAULT_CAROUSEL_SETTINGS = Object.freeze({
    dots: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true
            }
        }
    ]
});

export const SHADE_PICKER_SEPARATOR = ' ';

export enum contentSize {
    small = 'small',
    large = 'large',
    wide = 'wide',
    tall = 'tall',
    full = 'full'
}

export const CONTENT_SIZE_MAP: IContentSizeMap = Object.freeze({
    [contentSize.small]: {
        w: 1,
        h: 1
    },
    [contentSize.large]: {
        w: 2,
        h: 2
    },
    [contentSize.wide]: {
        w: 2,
        h: 1
    },
    [contentSize.tall]: {
        w: 1,
        h: 2
    },
    [contentSize.full]: {
        // width: 100%
        w: 0,
        // height: auto
        h: 0
    }
});

export enum gridItemType {
    product = 'product',
    tout = 'tout',
    featuredProduct = 'featured-product'
}
